var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-connected"},[_c('div',{attrs:{"id":"container"}},[_c('div',{staticClass:"block-flat document"},[_c('div',{staticClass:"block-content h-100"},[_vm._m(0),_c('iframe',{staticClass:"visu-doc",attrs:{"src":'https://grafana.clicmap.fr/goto/tSHscUEGz'}})])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('fieldset',[_c('legend',[_vm._v("Visualisation des statistiques")])])
}]

export { render, staticRenderFns }